<template><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.35 9.853a4.502 4.502 0 1 0 0-9.004 4.502 4.502 0 0 0 0 9.004Z" stroke="currentColor" stroke-width="1.5"/>
  <path d="M8.622 8.62 11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
</template>